<div id="breadcrumb">
    <div class="container">
        <div class="breadcrumb-wrapper">
            <h1>Service</h1>
            <ul>
                <li><a href="#">Home</a></li>
                <li><i class="bi bi-chevron-double-right"></i></li>
                <li><a href="#">Service</a></li>
            </ul>
        </div>
    </div>
</div>

<div id="service-section" class="page">
    <div class="container">
        <div class="row">
            <div class="col-md-6 col-lg-3">
                <div class="service-box">
                    <span class="service-number">01</span>
                    <div class="service-icon">
                        <i class="bi bi-brush"></i>
                    </div>
                    <div class="service-content">
                        <h4>Web Design</h4>
                        <p>Our product design service lets you prototype, test and validate your ideas.</p>
                        <a href="#" class="service-btn"><i class="bi bi-arrow-right"></i>Learn More</a>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-lg-3">
                <div class="service-box">
                    <span class="service-number">02</span>
                    <div class="service-icon">
                        <i class="bi bi-code-slash"></i>
                    </div>
                    <div class="service-content">
                        <h4>Development</h4>
                        <p>Our product design service lets you prototype, test and validate your ideas.</p>
                        <a href="#" class="service-btn"><i class="bi bi-arrow-right"></i>Learn More</a>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-lg-3">
                <div class="service-box">
                    <span class="service-number">03</span>
                    <div class="service-icon">
                        <i class="bi bi-graph-up"></i>
                    </div>
                    <div class="service-content">
                        <h4>Data Analytics</h4>
                        <p>Our product design service lets you prototype, test and validate your ideas.</p>
                        <a href="#" class="service-btn"><i class="bi bi-arrow-right"></i>Learn More</a>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-lg-3">
                <div class="service-box">
                    <span class="service-number">04</span>
                    <div class="service-icon">
                        <i class="bi bi-shield-shaded"></i>
                    </div>
                    <div class="service-content">
                        <h4>Cyber Security</h4>
                        <p>Our product design service lets you prototype, test and validate your ideas.</p>
                        <a href="#" class="service-btn"><i class="bi bi-arrow-right"></i>Learn More</a>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-lg-3">
                <div class="service-box">
                    <span class="service-number">05</span>
                    <div class="service-icon">
                        <i class="bi bi-shield-shaded"></i>
                    </div>
                    <div class="service-content">
                        <h4>Cyber Security</h4>
                        <p>Our product design service lets you prototype, test and validate your ideas.</p>
                        <a href="#" class="service-btn"><i class="bi bi-arrow-right"></i>Learn More</a>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-lg-3">
                <div class="service-box">
                    <span class="service-number">06</span>
                    <div class="service-icon">
                        <i class="bi bi-graph-up"></i>
                    </div>
                    <div class="service-content">
                        <h4>Data Analytics</h4>
                        <p>Our product design service lets you prototype, test and validate your ideas.</p>
                        <a href="#" class="service-btn"><i class="bi bi-arrow-right"></i>Learn More</a>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-lg-3">
                <div class="service-box">
                    <span class="service-number">07</span>
                    <div class="service-icon">
                        <i class="bi bi-code-slash"></i>
                    </div>
                    <div class="service-content">
                        <h4>Development</h4>
                        <p>Our product design service lets you prototype, test and validate your ideas.</p>
                        <a href="#" class="service-btn"><i class="bi bi-arrow-right"></i>Learn More</a>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-lg-3">
                <div class="service-box">
                    <span class="service-number">08</span>
                    <div class="service-icon">
                        <i class="bi bi-brush"></i>
                    </div>
                    <div class="service-content">
                        <h4>Web Design</h4>
                        <p>Our product design service lets you prototype, test and validate your ideas.</p>
                        <a href="#" class="service-btn"><i class="bi bi-arrow-right"></i>Learn More</a>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>



<footer id="footer">
    <div class="container">
        <div class="row">

            <!-- About Section -->
            <div class="col-md-6 col-lg-3">
                <div class="about">
                    <img class="logo" src="assets/icons/Transparent-2.png" alt="iTech Logo">
                    <p>
                        iTech is a leading IT solutions and consultancy provider, helping businesses
                        innovate, streamline operations, and achieve sustainable growth. From
                        software development to cloud transformation, we deliver secure, scalable,
                        and tailored solutions to meet your unique business needs.
                    </p>
                    <div class="social-icon">
                        <a href="#"><i class="bi bi-facebook"></i></a>
                        <a href="#"><i class="bi bi-twitter"></i></a>
                        <a href="#"><i class="bi bi-instagram"></i></a>
                    </div>
                </div>
            </div>

            <!-- Quick Links -->
            <div class="col-md-6 col-lg-3">
                <div class="quick-link">
                    <h4>Quick Links</h4>
                    <ul>
                        <li><a href="#">Product Design</a></li>
                        <li><a href="#">Application Development</a></li>
                        <li><a href="#">Cyber Security</a></li>
                        <li><a href="#">Data Quality Management</a></li>
                        <li><a href="#">IT Consultancy</a></li>
                        <li><a href="#">Mobile Development</a></li>
                        <li><a href="#">Cloud Migration</a></li>
                    </ul>
                </div>
            </div>

            <!-- Address -->
            <div class="col-md-6 col-lg-3">
                <div class="address">
                    <h4>Our Address</h4>
                    <img src="assets/images/img-footer-map.png" alt="Map">
                    <p>
                        <i class="bi bi-geo-alt-fill"></i>
                        <span>91 Western Road, Brighton, England</span>
                    </p>
                </div>
            </div>

            <!-- Contact Info -->
            <div class="col-md-6 col-lg-3">
                <div class="contact">
                    <h4>Contact Us</h4>

                    <div class="phone">
                        <p>
                            <i class="bi bi-telephone-fill"></i>
                            <a href="tel:+441632960896">+44 1632 960896</a>
                        </p>
                    </div>

                    <div class="email">
                        <p>
                            <i class="bi bi-envelope-fill"></i>
                            <a href="mailto:info@itech.com">info@itech.com</a>
                        </p>
                    </div>

                    <div class="subscribe">
                        <p>Subscribe to our Newsletter</p>
                        <form action="#">
                            <input type="email" placeholder="Your email" required>
                            <button type="submit"><i class="bi bi-arrow-right"></i></button>
                        </form>
                    </div>
                </div>
            </div>

        </div>

        <!-- Copyright -->
        <div class="copyright">
            <div class="left">
                <p>Copyright © 2025 iTech. All rights reserved.</p>
            </div>
            <div class="copyright-menu">
                <ul>
                    <li><a href="#">Terms & Condition</a></li>
                    <li><a href="#">Privacy Policy</a></li>
                    <li><a href="#">Contact Us</a></li>
                </ul>
            </div>
        </div>

    </div>
</footer>
